import React from "react";
import { Redirect } from "react-router-dom";
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { DataTableSkeleton } from "frontend/src/ui/data-table-skeleton";
import { DataTableLayout } from "frontend/src/ui/data-table-layout";
import { ButtonSkeleton } from "frontend/src/ui/button-skeleton";
import { BusinessOwnerLayout } from "frontend/src/pages/layouts";
import { paths } from "frontend/src/pages/paths/index";
import { Program } from "./program";
import { useCreateNewProgram, usePageModel } from "./model";
var RulesetTableHeaderLayout = function (_a) {
    var children = _a.children;
    return (React.createElement(Box, { display: "flex", justifyContent: "flex-end", alignItems: "center" }, children));
};
var Programs = function (_a) {
    var programs = _a.programs;
    return (React.createElement(TableContainer, { component: Paper },
        React.createElement(Table, null,
            React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, null, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
                    React.createElement(TableCell, null, "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F?"),
                    React.createElement(TableCell, { width: "5%" }, null),
                    React.createElement(TableCell, { width: "5%" }, null))),
            React.createElement(TableBody, null, programs.map(function (_a) {
                var id = _a.id, title = _a.title;
                return (React.createElement(Program, { key: id, id: id, title: title }));
            })))));
};
var NothingFound = function () { return (React.createElement(Box, { component: Paper, p: 2 },
    React.createElement(Typography, null, "\u041F\u043E\u043A\u0430 \u0447\u0442\u043E \u0437\u0434\u0435\u0441\u044C \u043D\u0435\u0442 \u043D\u0438 \u043E\u0434\u043D\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0432\u0435\u0449\u0430\u043D\u0438\u044F."))); };
var Page = function (_a) {
    var programs = _a.programs;
    var hasAnyPrograms = programs.length > 0;
    var _b = useCreateNewProgram(), create = _b.create, isLoading = _b.isLoading, data = _b.data, isSuccess = _b.isSuccess;
    var table = hasAnyPrograms ? (React.createElement(Programs, { programs: programs })) : (React.createElement(NothingFound, null));
    if (data && isSuccess) {
        return React.createElement(Redirect, { to: paths.business.owner.programs.edit(data.id) });
    }
    return (React.createElement(DataTableLayout, { header: React.createElement(RulesetTableHeaderLayout, null,
            React.createElement(ButtonLoader, { isLoading: isLoading, color: "primary", variant: "contained", startIcon: React.createElement(Add, { fontSize: "small" }), onClick: create }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C")), table: table }));
};
export var ProgramsPage = function () {
    var programs = usePageModel();
    return (React.createElement(BusinessOwnerLayout, null, programs.data ? (React.createElement(Page, { programs: programs.data })) : (React.createElement(DataTableSkeleton, { header: React.createElement(RulesetTableHeaderLayout, null,
            React.createElement(Skeleton, null,
                React.createElement(ButtonSkeleton, null))) }))));
};
